import { render, staticRenderFns } from "./event_camera.vue?vue&type=template&id=3ddb5bd7&scoped=true&"
import script from "./event_camera.vue?vue&type=script&lang=js&"
export * from "./event_camera.vue?vue&type=script&lang=js&"
import style0 from "./event_camera.vue?vue&type=style&index=0&id=3ddb5bd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddb5bd7",
  null
  
)

export default component.exports